import http from "./httpService";

const endPoint = "/api/v1/MovementTypes";

export async function getMovTypes() {
    return await http.get(endPoint);
}

export default {getMovTypes};


// WEBPACK FOOTER //
// ./src/services/movementTypeService.js